import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { FaLessThan,FaTrash, FaDownload } from 'react-icons/fa';
import QuestionType from "./QuestionType";
import Input from "reactstrap/lib/Input";
import FormGroup from "reactstrap/lib/FormGroup";
import { FaCheck } from 'react-icons/fa';
import Button from "reactstrap/lib/Button";
import { FileManager, FileUploader } from "reactjs-file-uploader";
import { API_URL, DOWNLOAD_API, UPLOAD_API } from "../../config";
import Progress from "reactstrap/lib/Progress";
import Universal20Service, { getAccessToken } from "../../services/Universal20Service";
import axios from "axios";
const { v4: uuidv4 } = require('uuid');

class QuestionFile extends QuestionType {
  constructor(props) {
    super(props);
    this.state = {
      files: []
    };

    this.uploadFiles = this.uploadFiles.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
  }

  getTextValue() {
    let txt = this.getValue();
    if (txt == null && this.hasVorauswahl()) {
      txt = this.getVorauswahl();
    }
    return txt;
  }

  getAllUploads() {
    let value =  this.getValue();
    if (typeof value === "undefined" || value == null) {
      return [];
    }

    if (typeof this.getValue() !== "string" && !Array.isArray(this.getValue())) {
      return [this.getValue()];
    }

    if (Array.isArray(this.getValue())) {
      return this.getValue();
    }

    try {
      const files = JSON.parse(this.getValue()).downloadFiles;
      if (typeof files !== "undefined" && files != null) {
        return files;
      }
    }
    catch (e) {

    }
    return [];
  }



  onFileUploaded(file, idata, data) {
    const responsedata = data.response;
    const filecreated = {
      name: file.filename,
      type: responsedata.files[0].mimeType,
      url: responsedata.files[0].url,
      id: responsedata.files[0]._id
    };
    this.setState({
      files: this.state.files.filter((f) => f.id != file.id)
    });

    this.setValue(JSON.stringify({
      downloadFiles: [filecreated]
    }));

  }

  renderAllUploadedFiles() {
    return this.getAllUploads().map((u) => {
      const url = (u.url) ? u.url : "/api/attachments/"+u.ref;
      return <div className={"upload-file-line row"}>
        <div className={"col-md-8 filename"}> {u.fileName ? u.fileName : u.name}</div>
        <div className={"col-md-4"}><a href={API_URL+url} target={"_blank"}><FaDownload /></a> <Button disabled={this.isFinished() || this.isDisabled()} onClick={(e) => this.deleteFile(u)}  color={"none"} size={"sm"}><FaTrash /></Button></div>
      </div>;
    });
  }

  onClickUploadFile(e) {
    document.getElementById("uploadinput-"+this.getId()).click();
  }

  static fileProgress({

                        /*
                        References to the Event objects.
                        Initial state is null and each propert gets assigned on Event.
                         */
                        uploadReady,
                        uploadStart,
                        uploadProgress,
                        uploadComplete,
                        downloadStart,
                        downloadProgress,
                        downloadComplete,
                        error,
                        abort,
                        timeout,

                        /*
                        The sequential state of the request
                        enum {
                            uploadReady, uploadStart, uploadProgress, uploadComplete, downloadStart
                            downloadStart, downloadProgress, downloadComplete
                        }
                         */
                        requestState,

                        /*
                        Function references to start / abort request
                          */
                        startUpload,
                        abortRequest,

                        /*
                        Request Object reference (XMLHttpReqeust)
                         */
                        request,

                        /*
                        Response text Object (JSON)
                         */
                        response,

                        /*
                        Data of the file being uploaded (if readData props is true)
                         */
                        fileData,

                      }) {
    return (
      <div className={"upload-file-line row"}>
        <div className={"filename col-md-6"}>{this.formData.file.name}</div>
        <div className={" col-md-6"}>{uploadProgress && <Progress value={uploadProgress.loaded / uploadProgress.total * 100} >{Number(uploadProgress.loaded / uploadProgress.total * 100).toFixed(2)}</Progress>}</div>
      </div>
    );
  }

  static buildID(file) {
    let filename = file.name.toString();
    if (filename.length > 100) {
      filename = filename.substring(filename.length-100, filename.length);
    }
    return QuestionFile.uniqueID()+"_"+filename;
  }

  static uniqueID() {
    return uuidv4().toString().substring(0,7);
  }

  hasUploadedFiles() {
    if (this.getAllUploads().length <= 0) {
      return false;
    }
    return true;
  }

  onFileSelected(event) {
    const fileList = Array.from(event.target.files);
    const mapppedList = fileList.map((file) => {
      return {
        filename: file.name,
        fileInfo: file,
        id: QuestionFile.buildID(file)
      };
    });

    this.setState({files: this.state.files.concat(mapppedList)});
  }

  uploadFile(file) {
    return (
      <FileUploader
        key={file.key}
        file={file}
        onDownloadComplete={(d, e) => this.onFileUploaded(file, d, e)}
        autoUpload={true}
        url={API_URL+UPLOAD_API+"/"+this.qCtrl().getId()+"/"+Universal20Service.getHostnameSubdomain()}
        formData={{
          file: file.fileInfo,
          id: file.id
        }}
        headers={{Authorization: "Bearer "+getAccessToken()}}
        readFile
      >
        {QuestionFile.fileProgress}
      </FileUploader>
    );
  }


  downloadFile(file) {
    const uri = API_URL+"/attachments"+file.id;
    var link = document.createElement("a", {target: "_blank"});
    // If you don't know the name or want to use
    // the webserver default set name = ''
    link.setAttribute('download', file.name);
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  deleteFile(file) {

    const file_id = (file.id) ? file.id : file._id;
    const files = this.getAllUploads().filter((f) => {
      const id = (f.id) ? f.id : f._id;
      if (id == file_id) {
        return false;
      }
      return true;
    } );
    const value = {
      downloadFiles: [
        ...files
      ]
    };
    this.setValue(JSON.stringify(value));
    /*axios.delete(API_URL+"/api/configurators/upload/"+file.id, {headers: {
        Authorization: "Bearer "+getAccessToken()
      }})
      .then(() => {

        this.setValue(JSON.stringify(value));
      });*/
    return value;
  }

  uploadFiles(files) {
    const _this = this;
    return files.map((file) => _this.uploadFile(file));
  }

  getUploadingFiles() {
    return this.state.files;
  }


  render() {
    return <div fluid={true} className={"rich-text-container "+(this.hasError() ? "error" : "")}>
      <div>
        <div className={"p-1"} md={12}>
          {this.isVorauswahl() && <FaCheck className={"vorauswahl_check"} onClick={(e) => this.onVorauswahlCheckClicked(e)}/>}
          {
          <div className={"upload-container"}>
            <input
              type="file"
              onChange={event => this.onFileSelected(event)}
              multiple
              id={"uploadinput-"+this.getId()}
              style={{display: "none"}}
            />
            {!this.hasUploadedFiles() &&
              <Button disabled={this.isFinished() || this.isDisabled()}
                      color={"primary"} onClick={(e) => this.onClickUploadFile(e)} size={"sm"}>
              Datei hochladen
              </Button>
            }
            <div
              className={"upload-block"}>
              <FileManager
                files={this.getUploadingFiles()}
              >
                {this.uploadFiles}
              </FileManager>
            </div>
            <div className={"all-files file-upload-question"}>
              {this.renderAllUploadedFiles()}
            </div>
          </div>}
          {this.renderErrors()}
        </div>
      </div>
    </div>;
  }
};

QuestionFile.propTypes = {

};


export default QuestionFile;
